module.exports = __webpack_public_path__ + "static/media/communityPad.144c60a5.png";